<template>
  <article class="auction-order">
    <group
      class="auction-manage fn-red"
      :title="keyToValue(auction_info.order_status_code, orderStatus)"
    >
      <cell
        :title="auction_info.car_model_name"
        :bdStart="bdStart"
        class="v-primary-lh"
      >
        <div
          slot="after-title"
          class="vux-label-desc mt"
        >{{auction_info.vin}}</div>
        <div
          class="service-icon"
          slot="icon"
        >
          <img :src="auction_info.car_image">
        </div>
      </cell>
      <div class="button-auction-inquiry">
        <div
          class="button-auction-info"
          @click="toAuctionInquiry('/auction/manage', auction_info.auction_car_id)"
        >
          <i class="icon icon-auction" />
          <span class="text">拍卖信息</span>
        </div>
        <div
          v-if="seeEnquiryAuth"
          class="button-inquiry-info"
          @click="toAuctionInquiry('/inquiry/inquiryList/inquirys', auction_info.auction_car_id)"
        >
          <i class="icon icon-inquiry" />
          <span class="text">询价信息</span>
        </div>
      </div>

      <cell class="no-top-border">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >订单编号</flexbox-item>
            <flexbox-item class="value">{{auction_info.order_id}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >中标金额</flexbox-item>
            <flexbox-item class="value">
              {{(auction_info.maximum_price / 100).toFixed(2)}}元
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >实收金额</flexbox-item>
            <flexbox-item class="value">
              {{(auction_info.actual_paid_amount / 100).toFixed(2)}}元
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >收车实价</flexbox-item>
            <flexbox-item class="value">{{auction_info.purchase_price | formatePrice}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >毛利率</flexbox-item>
            <flexbox-item class="value">{{auction_info.gross_profit_rate | formate}}</flexbox-item>
          </flexbox>
          <flexbox
            class="flexbox"
            v-if="this.channel === 5"
          >
            <flexbox-item
              :span="180/690"
              class="key"
            >线索来源</flexbox-item>
            <flexbox-item class="value">寄售</flexbox-item>
          </flexbox>
        </div>
      </cell>

      <!--3.已拍出，经销商选择关闭交易，且，不要保证金时-->
      <cell v-if="auction_info.order_status_code ===3 || auction_info.order_status_code ===4 || auction_info.order_status_code ===5">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >订单关闭</flexbox-item>
            <flexbox-item class="value">{{auction_info.closed_at}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >关闭理由</flexbox-item>
            <flexbox-item class="value">{{auction_info.close_reason}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >保证金问题</flexbox-item>
            <flexbox-item class="value">{{keyToValue(auction_info.penalize_amount_info, penalizeAmountInfo)}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >备注</flexbox-item>
            <flexbox-item class="value">{{auction_info.close_note}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
      <!--4.已拍出，经销商选择关闭交易，且，要保证金时，待平台处理5.已拍出，经销商选择关闭交易，且，要保证金时，平台已做处理时-->
      <cell v-if="auction_info.order_status_code ===4 || auction_info.order_status_code ===5">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >状态</flexbox-item>
            <flexbox-item class="value red">{{auction_info.order_status_code | getStatus}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >处理结果</flexbox-item>
            <flexbox-item class="value">{{keyToValue(auction_info.arbitration_result, arbitrationResult)}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
      <!--2.已拍出，经销商选择已付款时-->
      <cell v-if="auction_info.order_status_code ===2">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >收款时间</flexbox-item>
            <flexbox-item class="value">{{auction_info.paid_date}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >备注信息</flexbox-item>
            <flexbox-item class="value">{{auction_info.paid_note}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <group
      class="auction-manage"
      title="买家信息"
    >
      <cell
        :title="winner_info.name"
        class="winner-info"
      >
        <a
          slot="after-title"
          class="mt"
          @click="phoneCall()"
        >{{winner_info.mobile}}</a>
      </cell>
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >加入时间</flexbox-item>
            <flexbox-item class="value">{{winner_info.created_at}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >车商类型</flexbox-item>
            <flexbox-item class="value">{{winner_info.organization_type}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >车商名称</flexbox-item>
            <flexbox-item class="value">{{winner_info.organization_name}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >法人</flexbox-item>
            <flexbox-item class="value">{{winner_info.legal_person_name}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >所在地区</flexbox-item>
            <flexbox-item class="value">{{winner_info.province}}{{winner_info.city}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item
              :span="180/690"
              class="key"
            >具体地址</flexbox-item>
            <flexbox-item class="value">{{winner_info.address}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <div v-if="isReviewed">
      <div class="rate_list_title">评价信息</div>
      <rate-detail
        :review_type="review_info.review_type"
        :reviewer="review_info.reviewer"
        :content="review_info.content"
        :transfer_speed="review_info.transfer_speed"
        :dealer_professional="review_info.dealer_professional"
        :payment_speed="review_info.payment_speed"
        :images="review_info.images"
        :date="review_info.date"
      >
      </rate-detail>
    </div>
    <footer-btn
      v-if="toReview && hasReviewAuth"
      title="去评价"
      @submit="toRate"
    ></footer-btn>
    <!--1.已拍出，待经销商处理-->
    <section
      class="btn-bottom submit-btn"
      v-if="auction_info.order_status_code ===1"
    >
      <div class="btn-fix">
        <a
          class="btn status"
          @click.stop="closeOrReject(auction_info.order_id)"
        >关闭</a>
        <a
          class="btn"
          @click.stop.prevent="paidOrReject(auction_info.order_id)"
        >已收款</a>
      </div>
    </section>
  </article>
</template>
<script>
// 竞拍人详情
import { Cell, Group, Flexbox, FlexboxItem } from '@lx-frontend/cvux'
import RateDetail from '../components/RateDetail'
import FooterBtn from '../components/FooterBtn'
export default {
  components: {
    Cell,
    Group,
    Flexbox,
    FlexboxItem,
    RateDetail,
    FooterBtn
  },
  data() {
    return {
      auction_id: '',
      enquiry_id: '',
      channel: '', // 判断线索来源是否为寄售 5 为寄售
      bdStart: true,
      isReviewed: false,
      toReview: false,
      hasReviewAuth: false,
      seeEnquiryAuth: false,
      auction_info: {},
      winner_info: {},
      review_info: {},
      orderStatus: [
        {
          key: '1',
          value: '已拍出'
        }, {
          key: '2',
          value: '已收款'
        }, {
          key: '3',
          value: '已拍出（交易关闭）'
        }, {
          key: '4',
          value: '已拍出（交易关闭）'
        }, {
          key: '5',
          value: '已拍出（交易关闭）'
        }
      ],
      penalizeAmountInfo: [ // 保证金问题
        {
          key: '0',
          value: '不要买家保证金'
        }, {
          key: '1',
          value: '要买家赔偿保证金'
        }
      ],
      arbitrationResult: [
        {
          key: '0',
          value: '支持买家，解冻买家保证金。'
        }, {
          key: '1',
          value: '支持卖家，扣罚买家保证金，付给卖家。'
        }
      ]
    }
  },
  created() {
    let id = this.$route.params.id
    if (id) {
      this.$rest.auction.getOrderDetail(null, id).then((res) => {
        if (res.code === 0) {
          let data = res.data
          if (data) {
            let info = {
              need_review_flag: data.need_review_flag,
              auction_car_id: data.auction_info.auction_car_id,
              status: data.auction_info.order_status_code
            }
            this.auction_info = data.auction_info
            this.winner_info = data.winner_info
            this.auction_id = data.auction_info.auction_id
            this.enquiry_id = data.auction_info.enquiry_id
            this.channel = data.auction_info.channel
            return info
          }
        } else {
          this.showToast(res.message)
        }
      }).then(info => { // auction_car_id 和 订单状态已收款
        if (!info) return
        if (info.status !== 2) return // 订单是否完成
        if (info.need_review_flag === 1) { // 可以去评论
          this.toReview = true
        } else if (info.need_review_flag === 0) { // 已评论
          this.$rest.reviews.getReviewsDetail(null, info.auction_car_id).then((res) => {
            if (res.code === 0) {
              let len = res.data.images.length
              if (len > 0) {
                let arr = res.data.images.map(v => {
                  return { src: v }
                })
                res.data.images = arr
              }
              this.review_info = res.data
              this.isReviewed = true
            } else {
              this.showToast(res.message)
            }
          })
        }
      })
    }
  },
  mounted() {
    this.$store.state.promiseAuth.then(auth => {
      this.hasReviewAuth = auth.authList.includes('used_car_review.review.write')
      // 查看询价信息权限
      this.seeEnquiryAuth = auth.authList.includes('used_car_car.enquiry.view')
    })
  },
  methods: {
    toRate() {
      const carInfo = {
        car_image_url: this.auction_info.car_image,
        car_model_name: this.auction_info.car_model_name,
        vin: this.auction_info.vin
      }
      this.$store.commit('UPDATE_AUCTION_INFO', carInfo)
      this.$router.push(`/usedcar/reviewSubmit/${this.auction_info.auction_car_id}`)
    },
    toAuctionInquiry(path, carId) {
      this.$router.push({
        path: path,
        query: {
          operation: 'search',
          searchType: 'auction_car_id',
          value: carId
        }
      })
    },
    phoneCall() {
      window.location.href = 'tel:' + this.winner_info.mobile
    },
    keyToValue(optionId, arr) {
      optionId = optionId + ''
      if (optionId) {
        let filterArray = arr.find(v => v.key === optionId)
        if (filterArray) {
          return filterArray.value
        }
      } else {
        return '--'
      }
    },
    closeOrReject(orderId) {
      this.$router.push(`/auction/orderclose/${orderId}`)
    },
    paidOrReject(orderId) {
      this.$router.push(`/auction/paid/${orderId}?channel=${this.channel}`)
    }
  },
  computed: {},
  filters: {
    formatePrice(price) {
      return price ? `${(price / 100).toFixed(2)}元` : '--'
    },
    formate(price) {
      return price ? `${price}` : '--'
    },
    getStatus(status) {
      switch (status) {
        case 4: status = '待平台处理'
          break
        case 5: status = '已处理'
          break
        default: status = '--'
          break
      }
      return status
    }
  },
  watch: {
    auction_info (val) {
      const title = '订单收款确认'
      const desc = `${val.car_model_name} ${this.$route.query.plateNumber}`
      const imgUrl = val.car_image
      this.shareFriend({
        title,
        desc,
        imgUrl
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import '../../stylesheets/modules/manage/order.less';
.rate_list_title {
  padding-top: 30 / @w2;
  padding-left: 30 / @w2;
  padding-right: 30 / @w2;
  color: #000;
  font-size: 30 / @w2;
  line-height: 60 / @w2;
  opacity: 0.7;
}
</style>
